import router from "@/router";
import axios from "axios";
import qs from "qs";

// 获取Token的方法
export const getToken = (): string | null => {
  return localStorage.getItem("token");
};

// 设置Token的方法
export const setToken = (token: string): void => {
  localStorage.setItem("token", token);
};

// 获取 CSRF Token 的方法
// const getCsrfToken = () => {
//   const match = document.cookie.match(new RegExp("(?:^|; )XSRF-TOKEN=([^;]*)"));
//   return match ? match[1] : null;
// };

// 移除Token并跳转至登录页面
export const handleTokenExpired = (): void => {
  localStorage.removeItem("token");
  router.push({ name: "login" });
};

const http = axios.create({
  baseURL: "/ctr/",
  paramsSerializer: (params) => {
    return qs.stringify(params, { arrayFormat: "repeat" });
  },
});

const httpAuthorized = axios.create({
  baseURL: "/ctr/",
  paramsSerializer: (params) => {
    return qs.stringify(params, { arrayFormat: "repeat" });
  },
});

httpAuthorized.interceptors.request.use(
  async (config) => {
    // 所有写操作（POST/PUT/DELETE/PATCH）都需要携带 CSRF 令牌：
    // 后端 Spring Security 对非 GET 方法开启 CSRF 校验，缺失令牌的请求会被拒绝
    if (
      config.method &&
      ["post", "put", "delete", "patch"].includes(config.method)
    ) {
      try {
        const response = await axios.get("/ctr/csrf");
        if (response) {
          config.headers[response.data.headerName] = response.data.token; // 将令牌添加到请求头
        }
      } catch (error) {
        console.error("Failed to get CSRF token", error);
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 请求拦截器：在每个请求头中添加 CSRF Token
// httpAuthorized.interceptors.request.use(
//   (config) => {
//     const csrfToken = getCsrfToken();
//     if (csrfToken) {
//       console.log(btoa(csrfToken));
//       // config.headers["X-XSRF-TOKEN"] = btoa(csrfToken); // 添加 CSRF Token 到请求头
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// 请求拦截器，添加Authorization头
httpAuthorized.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers["Authorization"] = token;
    } else {
      // 如果没有token，直接跳转到登录页面
      handleTokenExpired();
      // 拒绝请求并返回一个拒绝的Promise
      return Promise.reject(new Error("未登录"));
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器，处理Token过期
httpAuthorized.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      handleTokenExpired();
    }
    return Promise.reject(error);
  }
);

export { http, httpAuthorized };
